import React from "react";
class PricingContent extends React.Component {
	render() {
		return (
			<section className="section " id="price" style={{backgroundColor:'#F4F5F7'}}>
				<div className="container">
					<div className="row mt-5" style={{margin:"0 10px",fontSize:"21px" }}>
						<strong>Current US Data Pricing</strong>
					</div>
					<div className="row mt-3">
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>1GB</li>
								<li>DAY PASS </li>
								<li className="price">$3.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>3GB</li>
								<li>30 DAYS </li>
								<li className="price">$10.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>10GB</li>
								<li>30 DAYS </li>
								<li className="price">$20.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>20GB</li>
								<li>30 DAYS </li>
								<li className="price">$30.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>30GB</li>
								<li>30 DAYS </li>
								<li className="price">$40.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>50GB</li>
								<li>30 DAYS </li>
								<li className="price">$50.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>100GB</li>
								<li>30 DAYS </li>
								<li className="price">$90.00 </li>
							</ul>
						</div>
					</div>
					<div className="row mt-5" style={{margin:"0 10px",fontSize:"21px" }}>
						<strong>
							{/*New US Data Pricing starting 8/1/2021*/}
							New US data pricing is postponed until further notice
						</strong>
					</div>
					<div className="row mt-3">
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>1GB</li>
								<li>DAY PASS </li>
								<li className="price">$3.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>3GB</li>
								<li>30 DAYS </li>
								<li className="price">$10.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>5GB</li>
								<li>30 DAYS </li>
								<li className="price">$20.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>10GB</li>
								<li>30 DAYS </li>
								<li className="price">$30.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>15GB</li>
								<li>30 DAYS </li>
								<li className="price">$35.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>20GB</li>
								<li>30 DAYS </li>
								<li className="price">$40.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>30GB</li>
								<li>30 DAYS </li>
								<li className="price">$50.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>50GB</li>
								<li>30 DAYS </li>
								<li className="price">$70.00 </li>
							</ul>
						</div>
						<div className="col-lg-6 new-price-box">
							<ul>
								<li>100GB</li>
								<li>30 DAYS </li>
								<li className="price">$120.00 </li>
							</ul>
						</div>
					</div>
					<div className="row mt-5" style={{margin:"20px" }}>
						<h2 style={{width:"100%"}}>Disclaimer:</h2>
						<div style={{fontSize:"18px"}}><strong>Prices and/or data sizes may be changed at any time without prior notice. </strong><br/>
							We reserve the right to change our data plans at any time without prior notice.</div>
					</div>
				</div>
			</section>
		);
	}
}

export default PricingContent;



// WEBPACK FOOTER //
// ./src/pages/newpricing/PricingContent.js